import { createFileRoute } from '@tanstack/react-router';

import { InviteCallbackPage } from '@/features/auth/InviteCallbackPage';

/**
 * Magic-link landing for invitees.
 *
 * Owners send invitees a magic link with `?planId=<id>` so the post-sign-in
 * handoff knows where to land. Once Supabase has consumed the code and
 * signed the user in, the page resolves any pending `floorplan_collaborators`
 * rows whose `invited_email` matches the signed-in email, then redirects
 * to `/plans/:planId`. Idempotent on re-click.
 */
export const Route = createFileRoute('/auth/invite-callback')({
  component: InviteCallbackPage,
  validateSearch: (search): { planId?: string } => ({
    planId: typeof search.planId === 'string' ? search.planId : undefined,
  }),
});
